<template>
<div id="app">
    <router-view />
</div>
</template>

<script>
import '@/assets/js/bootstrap.min.js';

export default {
  name: 'App',
};
</script>

<style>
@import url("./assets/css/common/bootstrap.css");
@import url("./assets/css/common/bootstrap-theme.css");
@import url("./assets/css/common/formparts.css");
@import url("./assets/css/common/common_pc.css");
@import url("./assets/css/common/common_sp.css");
@import url("./assets/css/common/style_pc.css");
@import url("./assets/css/common/style_sp.css");
@import url("./assets/css/common.css");
@import "select2/dist/css/select2.css";

@media print {
    body {
        background-color: #ffffff;
    }
}

@media all and (-ms-high-contrast: none),
(-ms-high-contrast: active) {

    /* IE10+ CSS */
    table.dataTable thead .sorting {
        background: url('./assets/img/common/sort_both.png') no-repeat center right;
    }

    table.dataTable thead .sorting_asc {
        background: url('./assets/img/common/sort_asc.png') no-repeat center right;
    }

    table.dataTable thead .sorting_desc {
        background: url('./assets/img/common/sort_desc.png') no-repeat center right;
    }
}
</style>
